// extracted by mini-css-extract-plugin
module.exports = {"shine":"styles_shine__x3_Fv","clickEffect":"styles_clickEffect__1pdLn","pulse":"styles_pulse__whSBO","rotateShine":"styles_rotateShine__nT9zf"};